<template>
  <div class = "st-table">
    <el-card shadow="always" style="width: 100%">
        <el-form :model="query" label-position="top" label-width="" class = "el-form–label-top">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="Product Name">
                <el-select
                  v-model="query.product_id"
                  filterable
                  clearable
                  style="width: 80%"
                >
                  <el-option
                    v-for="item in this.productList"
                    :key="item.index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="Product Manager"
                :span="6"
              >
                <el-select
                  v-model="query.pm_id"
                  filterable
                  clearable
                  style="width: 80%"
                  :loading="loading1"
                >
                  <el-option
                    v-for="(option) in pmList"
                    :value="option.value"
                    :key="option.label"
                    :label="option.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Company" prop="company_name">
                <el-select v-model="query.company_name"
                           clearable
                           filterable
                           style="width: 80%"
                           remote
                           transfer="true"
                           :remote-method="fetchCompany"
                           :loading="isCompanyFetching"
                           @change="onCompanyChange"
                           >
                  <el-option
                    v-for="(item, index) in this.companyList"
                    :value="item.value"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sub Company">
                <el-select v-model="query.sub_company_name"
                           clearable
                           style="width: 80%"
                >
                  <el-option
                    v-for="(item, index) in this.subCompanyList"
                    :value="item"
                    :key="index"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="Accept">
                <el-select
                  v-model="query.accept"
                  style="width: 80%"
                  clearable
                >
                  <el-option
                    v-for="item in this.options.acceptList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Status">
                <el-select
                  v-model="query.status"
                  clearable
                  style="width: 80%"
                >
                  <el-option
                    v-for="item in this.options.statusList"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="16">
            <el-col :span="3">
              <el-button type="text" class="btn" @click="handleReset">
                Reset
              </el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="primary" class="btn" @click="getRequirementList">
                Search
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    <br/>
    <el-card shadow="always" title="Requirement List" style="width: 100%">
      <el-form>
        <el-table
          :data="reqsList" border
          style="width: 100%"
          row-key="id"
          lazy
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        >
          <el-table-column
            prop="reqNo"
            label="ID#"
          >
          </el-table-column>
          <el-table-column
            prop="productName"
            label="Product"
          >
          </el-table-column>
          <el-table-column
            prop="version"
            label="User Version"
          >
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="Company Name"
          >
          </el-table-column>
          <el-table-column
            prop="subCompanyName"
            label="Sub Company"
          >
          </el-table-column>
          <el-table-column
            prop="outline"
            label="Req.Outline"
          >
          </el-table-column>
          <el-table-column
            prop="projectManager"
            label="Product Manager"
          >
          </el-table-column>
          <el-table-column
            prop="accept"
            label="Accept"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
          >
          </el-table-column>
          <el-table-column
            prop="planVersion"
            label="Plan Version"
          >
          </el-table-column>
          <el-table-column
            prop="actualVersion"
            label="Actual Version"
          >
          </el-table-column>
          <el-table-column
            label="Action"
            width="180">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="small"
                  v-if="scope.row.type==='main'"
                  style="margin-right: 5px"
                  @click="handleBreakRouter(scope.$index, scope.row)">
                  Break
                </el-button>
                <el-button
                  size="small"
                  type="danger"
                  @click="handleEditRouter(scope.$index, scope.row)"
                >
                  Edit
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="query.currentPage"
          :page-sizes="[10,20,50]"
          :total="query.totalPage"
          :page-size.sync="query.pageSize"
          prev-text="Previous"
          next-text="Next"
          style="margin-top: 4px"
          show-total
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-form>
    </el-card>

    <br/>

  </div>

</template>

<script>
import reqApi from "@/api/req";
import _ from "lodash";
import userApi from "@/api/user";
import productApi from "@/api/product";
import {PathName} from "@/constant/routeData";
// import userApi from '@/api/user.js'


export default {
  name: "requirementList",
  data() {
    return {
      companyList: [],
      subCompanyList: [],
      productList:[],
      reqsList:[],
      pmList:[],
      options: {
        acceptList:['Accepted','Decline','Partially Accepted'],
        statusList:['To Do','In Progress','Hold','Complete'],
      },
      loading1: false,
      editIndex: -1,
      isEdit: -99,
      isCompanyFetching:'',
      query: {
        user: '',
        product_id: '',
        accept:'',
        status: '',
        company_name: '',
        sub_company_name: '',
        pm_id:'',
        plan_version:'',
        pageSize: 10,
        totalPage: 0,
      },
    }
  },
  methods: {
    onCompanyChange(val) {
      Object.assign(this.query, {
        sub_company_name: undefined,
      })
      this.fetchSubCompany(val)
    },
    fetchCompany(query) {
      if (query !== '') {
        this.isCompanyFetching = true
        reqApi.getCompany(query.trim()).then(({data}) => {
          this.isCompanyFetching = false
          this.companyList = (data.data || []).map(item => {
            return {
              value: item,
              label: item,
              key: item,
            }
          })
        })
      } else {
        this.companyList = []
      }
    },
    fetchSubCompany(company_name) {
      reqApi.getSubCompany(company_name).then(res => {
        this.subCompanyList = res.data.data
      })
    },
    getRequirementList(){
      let para = {}
      para['offset'] = this.query.pageSize * (this.query.currentPage -1)
      para['limit'] = this.query.pageSize
      if (this.query.product_id) {
        para['product_id'] = this.query.product_id
      }
      if (this.query.pm_id) {
        para['pm_id'] = this.query.pm_id
      }
      if (this.query.company_name) {
        para['company_name'] = this.query.company_name
      }
      if (this.query.sub_company_name) {
        para['sub_company_name'] = this.query.sub_company_name
      }
      if (this.query.accept) {
        para['accept'] = this.query.accept
      }
      if (this.query.status) {
        para['status'] = this.query.status
      }
      reqApi.getReqs(para).then(
        res => {
          this.reqsList = res.data.data
          this.query.totalPage = res.data.total
        }
      )
    },
    deleteReq(index, row){
      this.$confirm('Delete the requirement, continue?', 'Tips', {
        type: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
      }).then(() => {
        let para = { id: row.id }
        reqApi.delReqs(para).then(resp => {
          this.$message.success({
            message: resp['msg'],
            type: "success"
          })
          this.getRequirementList()
        })
      })
    },
    handleEditRouter(index,row) {
      const id = row.id
      let routeData = this.$router.resolve({name: PathName.ReqEdit, query:{reqId:id}});
      window.open(routeData.href, '_blank');
    },
    handleBreakRouter(index, row) {
      const id = row.id
      let routeData = this.$router.resolve({name: PathName.SubReqRequest, query:{reqId:id}});
      window.open(routeData.href, '_blank');
  },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getRequirementList()
      // 在此刷新数据
    },
    handleCurrentChange(val){
      this.query.currentPage = val
      this.getRequirementList()
    },
    getSelects() {
      userApi.getUsers().then(res=> {
        let users = res.data
        for (let user of users) {
          this.pmList.push({value: user.id, label: user['fullName']})
        }
      })
      productApi.getProducts().then(res=> {
          let products = res.data
          for (let product of products) {
            this.productList.push({value: product.id, label: product.name})
          }
        }
      )

    },
    handleReset() {
      this.query.product_id = null
      this.query.pm_id = null
      this.query.company_name = null
      this.query.sub_company_name = null
      this.query.accept = null
      this.query.status = null
    },
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        const newCompanyName = _.get(newVal, 'company_name')
        if (newCompanyName && !_.get(oldVal, 'company_name')) {
          this.fetchCompany(newCompanyName)
          this.fetchSubCompany(newCompanyName)
        }
      }
    },
  },
  mounted(){
    this.getSelects()
  },
  // mounted() {
  // }
}
</script>


<style lang="scss" scoped>
.st-table {
  padding:10px
}
.el-form–label-top {
  text-align: left !important;
}

</style>
